<script setup lang="ts">
import { ref, watch } from "vue";
import { requestPasswordReset } from "../../auth/api";
import { t } from "../../i18n";
import { appStore } from "../../stores/app";
import AppModal from "../common/AppModal.vue";

// Forgot password: the e-mail field is cleared every time the modal opens
const forgotPasswordEmail = ref("");
const isSending = ref(false);
watch(() => appStore.modal, modal => {
    if (modal === "forgotPassword") forgotPasswordEmail.value = "";
});

async function sendForgotPassword() {
    isSending.value = true;
    try {
        if (await requestPasswordReset(forgotPasswordEmail.value)) {
            appStore.modal = "forgotPasswordConfirmation";
        }
    } finally {
        isSending.value = false;
    }
}

function closeResetPasswordConfirmation() {
    appStore.modal = null;
    window.location.href = "/";
}
</script>

<template>
    <AppModal class="changepassword-modal" name="changePassword" :title="t('modal.changepassword.header')" outer-close v-slot="{ close }">
        <div class="mb-6" v-html="t('modal.changepassword.body')"></div>
        <div class="field center">
            <div class="control is-flex is-justify-content-center">
                <button class="button is-default is-dark is-radiusless changepassword-close" aria-label="close" @click="close">
                    <span v-html="t('common.close')"></span>
                </button>
            </div>
        </div>
    </AppModal>

    <AppModal class="forgotpassword-modal" name="forgotPassword" :title="t('modal.forgotpassword.header')">
        <div class="mb-6" v-html="t('modal.forgotpassword.body')"></div>
        <form id="forgotpasswordform" class="form pl-6 pr-6" @submit.prevent="sendForgotPassword">
            <div class="field is-horizontal mb-6">
                <div class="field-label is-flex is-align-items-center is-justify-content-end">
                    <label class="label"><span v-html="t('common.email')"></span><span>*:</span></label>
                </div>
                <div class="field-body">
                    <div class="simple-input field">
                        <p class="control is-expanded">
                            <input id="forgotpassword-email" v-model="forgotPasswordEmail" required class="input is-shadowless is-radiusless" type="text">
                        </p>
                    </div>
                </div>
            </div>
            <div class="field center">
                <div class="control is-flex is-justify-content-center">
                    <button type="submit" class="button is-default is-dark is-radiusless forgotpassword-send" :class="{ 'is-loading': isSending }" aria-label="send">
                        <span v-html="t('common.send')"></span>
                    </button>
                </div>
            </div>
        </form>
    </AppModal>

    <AppModal class="forgotpasswordconfirmation-modal" name="forgotPasswordConfirmation" :title="t('modal.forgotpasswordconfirmation.header')" v-slot="{ close }">
        <div class="mb-6" v-html="t('modal.forgotpasswordconfirmation.body')"></div>
        <div class="field center">
            <div class="control is-flex is-justify-content-center">
                <button class="button is-default is-dark is-radiusless forgotpasswordconfirmation-close mr-4" aria-label="close" @click="close">
                    <span v-html="t('common.close')"></span>
                </button>
            </div>
        </div>
    </AppModal>

    <AppModal class="resetpasswordconfirmation-modal" name="resetPasswordConfirmation" :title="t('modal.resetpasswordconfirmation.header')">
        <div class="mb-6" v-html="t('modal.resetpasswordconfirmation.body')"></div>
        <div class="field center">
            <div class="control is-flex is-justify-content-center">
                <button class="button is-default is-dark is-radiusless resetpasswordconfirmation-close mr-4" aria-label="close" @click="closeResetPasswordConfirmation">
                    <span v-html="t('common.close')"></span>
                </button>
            </div>
        </div>
    </AppModal>
</template>
